"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = exports.Button = exports.PresetThemes = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_button_1 = require("@travelnest/merlin.button");
const theme_1 = __importDefault(require("../styles/theme"));
var PresetThemes;
(function (PresetThemes) {
    PresetThemes["Primary"] = "Primary";
    PresetThemes["Neutral"] = "Neutral";
})(PresetThemes = exports.PresetThemes || (exports.PresetThemes = {}));
;
const presetThemes = {
    Primary: {
        color: theme_1.default.colours.neutral.white,
        bgColor: theme_1.default.colours.success.primary,
        hoverColor: theme_1.default.colours.success.primary,
        activeColor: theme_1.default.colours.success.primary,
    },
    Neutral: {
        color: theme_1.default.colours.neutral.darkest,
        bgColor: theme_1.default.colours.neutral.lightest,
        hoverColor: theme_1.default.colours.neutral.light,
        activeColor: theme_1.default.colours.neutral.light,
    },
};
const StyledMerlinButton = (0, styled_1.default)(merlin_button_1.Button) `
	${theme_1.default.typography.button}
	color: ${props => props.color};
	// line-height overwrites setting in Merlin component that conflicts with the Portal value of 1.15
	line-height: 1.15;

	opacity: ${props => { var _a; return ((_a = props.className) === null || _a === void 0 ? void 0 : _a.includes('full-opacity')) && 1; }};

	// Add support for Primary buttons to stay the correct colour when loading
	// TODO: Port back into Merlin button
	&.merlin-button--loading,
	&.merlin-button--loading:active,
	&.merlin-button--loading:focus,
	&.merlin-button--loading:hover {
		background-color: ${(props) => props.bgColor || presetThemes.Neutral.bgColor} !important;
		color: ${(props) => props.color || presetThemes.Neutral.color} !important;
	}
`;
const StyledMerlinLink = (0, styled_1.default)(merlin_button_1.LinkButton) `
	${theme_1.default.typography.button}
	color: ${props => props.color};
`;
const Button = (_a) => {
    var { buttonType, children } = _a, rest = __rest(_a, ["buttonType", "children"]);
    const buttonTheme = buttonType ? presetThemes[buttonType] : presetThemes.Neutral;
    return react_1.default.createElement(StyledMerlinButton, Object.assign({}, buttonTheme, rest), children);
};
exports.Button = Button;
const LinkButton = (_a) => {
    var { buttonType, children } = _a, rest = __rest(_a, ["buttonType", "children"]);
    const buttonTheme = buttonType ? presetThemes[buttonType] : presetThemes.Neutral;
    return react_1.default.createElement(StyledMerlinLink, Object.assign({}, buttonTheme, rest), children);
};
exports.LinkButton = LinkButton;
//# sourceMappingURL=Button.js.map